export class AccountingPoint {
  account_point_rid: number;
  account_point_number: number;
  account_point_name: string;
  account_point_full_address_name___ru: string;
  account_point_full_address_name___kz: string;
  meter_next_verify_date: Date;
  net_node_name: string;
  tarif_value: number;
  row_count: number;
  is_connected: boolean;
}
